import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Container)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;

export const BackgroundMediaContainer = styled(Box)<{
  $mediaAnimationEffect: Maybe<string>;
}>`
  width: 100%;
  position: relative;
  overflow: hidden;
  ${({ $mediaAnimationEffect }) => css`
    ${$mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}
  `};
`;

export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  ${({ $backgroundAlignment, theme }) => css`
    height: 100%;
    width: 88%;
    ${$backgroundAlignment === 'right' && 'float: right;'}
    ${theme.media.md.down} {
      float: unset;
      height: unset;
      width: 100%;
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;

export const WatchImage = styled(NextImageWithLoader)<{
  $backgroundAlignment: Maybe<string>;
}>`
  .next-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${({ $backgroundAlignment, theme }) => css`
    .next-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(1.4) translateX(5%);
    }
    margin-bottom: 12%;
    transform: translateX(0);
    ${theme.media.md.up} {
      .next-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transform: scale(0.8) translateX(0);
      }
      height: 100%;
      ${$backgroundAlignment === 'right'
        ? 'transform: translateX(-21%);'
        : 'transform: translateX(16%);'}
    }
  `}
`;
export const WatchWrapper = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  ${({ $backgroundAlignment, theme }) => css`
    display: flex;
    flex-direction: row;
    margin-top: -35%;
    position: relative;
    z-index: 1;
    right: 0;
    width: 100%;
    pointer-events: none;
    ${theme.media.md.up} {
      position: absolute;
      height: 100%;
      top: 0;
      margin-top: 0;
      display: flex;
      flex-direction: ${$backgroundAlignment === 'right'
        ? 'row-reverse'
        : 'row'};
    }
  `}
`;
export const WatchContainer = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 100%;
    ${theme.media.md.up} {
      width: 100%;
      height: 100%;
      display: flex;
      flexdirection: column;
      justifycontent: center;
    }
  `}
`;
export const StyledFlexItem = styled(Box)`
  width: 100%;
  height: 100%;
`;
